import {lastOf} from "@/utils";

function getFibreFromModelSpans({ modelSpans, hasCantilever }) {
    const mainSpans = hasCantilever ? modelSpans.slice(1, -1) : modelSpans;

    return mainSpans.map(span => {
        let item;

        if (span < 3.5) item = 0;
        else if (span < 7) item = 1;
        else if (span < 10.5) item = 2;
        else if (span < 14) item = 3;
        else if (span < 17.5) item = 4;
        else if (span < 20.5) item = 5;

        return item;
    })
}

function getType2SpanRestraints({ direction, format, modelSpans, hasCantilever }) {
    const mainSpans = hasCantilever ? modelSpans.slice(1, -1) : modelSpans;

    const spanRestraints = {
        upperFibre: [],
        lowerFibre: []
    };

    if (direction === 1) {
        //horizontal

        if (format === 1) {
            spanRestraints.upperFibre = Array(mainSpans.length).fill(0);
        } else if (format === 2) {
            spanRestraints.upperFibre = Array(mainSpans.length).fill(-1);
        }

        spanRestraints.lowerFibre = getFibreFromModelSpans({ modelSpans, hasCantilever });

    } else if (direction === 2) {
        spanRestraints.upperFibre = Array(mainSpans.length).fill(-1);
        spanRestraints.lowerFibre = Array(mainSpans.length).fill(0);
    }

    return spanRestraints;
}

function patchSpanRestraints(spanRestraints, { type, direction, format, modelSpans, hasCantilever }) {
    if (type === 2) {
        return getType2SpanRestraints({ direction, format, modelSpans, hasCantilever })
    } else {
        return spanRestraints;
    }
}

function patchDeformationLimit(deformationLimit, { type }) {
    if (type === 3) {
        return 250;
    }

    return deformationLimit;
}

function getOpinionatedSpanRestraints({
    direction,
    format,
    modelSpans,
    hasCantilever,
    type,
    spanRestraintsDefaults,
    noSpans
}) {
    if (type === 2 || type === 3) {
        return getType2SpanRestraints({
            direction,
            format,
            modelSpans,
            hasCantilever,
        });
    } else {

        const spanRestraintsDefaultsOfSelectedType =
            spanRestraintsDefaults[type];

        return {
            upperFibre: Array(noSpans).fill(
                spanRestraintsDefaultsOfSelectedType.upperFibre
            ),
            lowerFibre: Array(noSpans).fill(
                spanRestraintsDefaultsOfSelectedType.lowerFibre
            ),
        };
    }
}

function getUnopinionatedSpanRestraints({ mainSpans, currentSpanRestraints }) {
    const newSpanRestraintsLength = mainSpans.length;
    const oldSpanRestraintsLength = currentSpanRestraints.upperFibre.length; //we could as well get the length from lowerFibre
    const diff = newSpanRestraintsLength - oldSpanRestraintsLength;

    if (!diff) {
        return currentSpanRestraints;
    }

    const added = diff > 0;

    const newSpanRestraints = {
        upperFibre: [],
        lowerFibre: [],
    };

    Object.entries(currentSpanRestraints).forEach(([type, val]) => {
        if (added) {
            newSpanRestraints[type] = [...val, ...Array(diff).fill(lastOf(val))];
        } else {
            //subtracted
            newSpanRestraints[type] = val.slice(0, diff);
        }
    });

    return newSpanRestraints;
}


export default {
    getFibreFromModelSpans,
    patchSpanRestraints,
    patchDeformationLimit,
    getOpinionatedSpanRestraints,
    getUnopinionatedSpanRestraints
}